import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import GroupsIcon from '@mui/icons-material/Groups';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import HistoryIcon from '@mui/icons-material/History';



const drawerWidth = 240;

function PanelClients(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Obtener la ubicación actual

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/iniciar-sesion');
  };

  // Definir las rutas y sus nombres
  const routes = [
    { path: '/clientes', name: 'Clientes', icon: <GroupsIcon /> },
    { path: '/turnos', name: 'Turnos', icon: <BackupTableIcon /> },
    { path: '/turnos-finalizados', name: 'Turnos Finalizados', icon: <PivotTableChartIcon /> },
    { path: '/historial', name: 'Historial', icon: <HistoryIcon /> },
  ];
  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {routes.map(({ path, name, icon }) => (
          <Link to={path} style={{ textDecoration: 'none', color: 'black' }} key={name} onClick={handleDrawerClose}>
            <ListItem disablePadding>
              <ListItemButton sx={{ backgroundColor: location.pathname === path ? '#1976d2' : 'transparent', color: location.pathname === path ? 'white' : 'black', ":hover": {backgroundColor: '#1976d2'} }}>
                <ListItemIcon sx={{color: location.pathname === path ? 'white' : 'black'}}>
                  {icon}
                </ListItemIcon>
                <ListItemText primary={name} />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesión" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Panel de Clientes
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` }, }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}

PanelClients.propTypes = {
  window: PropTypes.func,
};

export default PanelClients;
